<template>
  <JoszakiCard
    :key="inspiration.id"
    class="relative grid max-md:grid-rows-[auto_1fr] md:grid-cols-[auto_1fr] gap-3 md:gap-6 cursor-pointer"
    hoverable
    @click.native="$router.push(inspiration.url)"
  >
    <FavouriteButton
      :entity-type="FAVOURITE_ENTITY_TYPES.INSPIRATION"
      :entity-id="inspiration.id"
      wrapper-class="absolute top-3 right-3 z-10"
      button-class="text-primary"
    />
    <div
      class="w-full md:w-80 relative overflow-hidden max-md:h-52 md:[contain:size]"
    >
      <img
        v-lazy-load :data-src="inspiration.photoSrc"
        :alt="inspiration.name"
        class="object-cover w-full max-h-full rounded-md"
        @error="$helpers.noImage"
      />
    </div>
    <div>
      <JoszakiHeading :level="2">
        {{ inspiration.name }}
      </JoszakiHeading>
      <JoszakiMarkdownTextBlock
        v-if="inspiration.descriptionMarkdown"
        :text="inspiration.descriptionMarkdown"
      />
      <JoszakiButton class="mt-2">
        {{
          $t("inspirations.moreInspiratonsOf", {
            inspirationName: inspiration.name,
          })
        }}
      </JoszakiButton>
    </div>
  </JoszakiCard>
</template>

<script>
import JoszakiMarkdownTextBlock from "~/components/_refactored/common/JoszakiMarkdownTextBlock.vue";
import FavouriteButton from "~/components/_refactored/favourite/FavouriteButton.vue";
import { FAVOURITE_ENTITY_TYPES } from "~/composables/favourite/favouriteEntityTypes";

export default {
  name: "InspirationListItem",
  components: {
    JoszakiMarkdownTextBlock,
    FavouriteButton,
  },
  props: {
    inspiration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      FAVOURITE_ENTITY_TYPES,
    };
  },
};
</script>
